import React from "react";
import { Grid, Typography } from "@material-ui/core";
import Page from "../layouts/pages/PageLayout";
import SimpleTable from "../components/worker/tables/SimpleTable";

function WorkerPage() {
  return (
    <Page
      header={
        <Grid item xs={12}>
          <Typography variant="h5" color="secondary">
            Worker Page
          </Typography>
        </Grid>
      }
    >
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ marginTop: 20 }}
      >
        <SimpleTable />
      </Grid>
    </Page>
  );
}

export default WorkerPage;
